import ReactTooltip from 'react-tooltip'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons'

export const ErrorContent = ({ name, errorText }) => (
  <span className="d-block ml-4">
    <FontAwesomeIcon icon={faCircleExclamation} size="lg" className="color-red" data-tip data-for={name} />
    <ReactTooltip id={name} type="error" className="error-tooltip">
      {errorText}
    </ReactTooltip>
  </span>
)
